var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('b-breadcrumb',{staticClass:"page-breadcrumb",attrs:{"items":_vm.items}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }